// @ts-nocheck
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import OrbcommLogo11 from '../../images/ORBCOMMLOGOR.svg';

const LoginOauthJP = () => {
    var url: string;
    var baseUrl: string;
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    url = window.location.href;
    const { user,
        isAuthenticated,
        loginWithRedirect,
        logout, } = useAuth0();

    if (isAuthenticated) {
        console.log('user authenticated');
    }

    useEffect(() => {
       loginWithRedirect({
            appState: {
                returnTo: "/authOUserProfile",
            },
            authorizationParams: {
                prompt: "login",
            },
        });
    }, []);

    return (
        <div className="d-grid">
           
        </div>
    );
};


export default LoginOauthJP;